import React from 'react';
import PageHeader from '../PageHeader';
import RulesHeaderLeft from './RulesHeaderLeft';
import RulesHeaderRight from './RulesHeaderRight';
import DeployButton from './DeployButton';
import ScheduledDeploymentButton from './ScheduledDeploymentButton';

type RulesHeaderComponents = {
    Left: typeof RulesHeaderLeft;
    Right: typeof RulesHeaderRight;
    DeployButton: typeof DeployButton;
    ScheduledDeploymentButton: typeof ScheduledDeploymentButton;
};

const RulesHeader: React.FC<JSX.IntrinsicElements['div']> & RulesHeaderComponents = ({ children, ...props }) => {
    return <PageHeader {...props}>{children}</PageHeader>;
};

RulesHeader.Left = RulesHeaderLeft;
RulesHeader.Right = RulesHeaderRight;
RulesHeader.DeployButton = DeployButton;
RulesHeader.ScheduledDeploymentButton = ScheduledDeploymentButton;

export default RulesHeader;
